module.exports = __webpack_public_path__ + "static/media/iconSepultura3.f191906c.svg";